<template>
  <div
    class="common-menu"
    :id="containerId"
    :style="{
      backgroundColor: bgColor
    }"
  >
    <el-menu
      ref="commonMenu"
      :show-timeout="200"
      :default-active="activeMenu"
      :background-color="bgColor"
      :id="scrollBoxId"
      :default-openeds="defaultOpeneds"
      mode="vertical"
      active-text-color="#2E8FF1"
      class="sidebar-el-menu"
      @select="handleMenuSelect"
      @open="openSubmenu"
      @close="closeSubmenu"
    >
      <slot name="secondMenuTop"></slot>
      <template>
        <sidebar-item
          v-for="route in menuList"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :indexNum="1"
        />
      </template>
      <slot name="secondMenuBottom"></slot>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './components/SidebarItem'

export default {
  name: 'CustomMenu',
  components: { SidebarItem },
  inject: ['parentLayout'],
  props: [
    'menuList',
    'containerId',
    'scrollBoxId',
    'bgColor',
    'defaultOpeneds',
  ],
  computed: {
    ...mapGetters(['sidebar', 'isAppLoading', 'clickSecondMenuUrl']),
    // eslint-disable-next-line vue/no-unused-properties
    routes() {
      return this.$router.options.routes
    },
    // eslint-disable-next-line vue/no-unused-properties
    isCollapse() {
      return !this.sidebar.opened
    },
    // eslint-disable-next-line vue/no-unused-properties
    pathname() {
      return location.pathname.split('/')[1]
    },
  },
  data() {
    return {
      activeMenu: '',
      // isQiankun: window.__POWERED_BY_QIANKUN__,
      canScroll: true, // 点击切换tab不进行菜单重定位
      subMenuClick: false,
    }
  },
  methods: {
    // 隐藏菜单场景：对应一个左侧的目录高亮（热更或刷新时触发）
    _getCurrentActiveMenu(meta, name, path) {
      // const { path, meta, name } = this.$route
      this.activeMenu = path
      if (meta && meta.levels && meta.levels.length) {
        const { levels } = meta
        let parentList = this.menuList
        let parentItem = null
        for (const i in levels) {
          const parent1 = parentList.find(
            (item) => item.resourceKey === levels[i],
          )
          if (parent1) {
            parentItem = parent1
            parentList = parent1.children
          }
        }
        // 只考虑隐藏菜单场景
        if (parentItem && parentList && parentList.length) {
          const cur = parentList.find((item) => item.resourceKey === name)
          if (!(cur && cur.hidden)) {
            return false
          }
        } else {
          return false
        }
        // 父级是页面时，直接高亮父级
        if (parentItem && parentItem.resourceType === 1) {
          this.activeMenu = parentItem.path
          return false
        }
        // 父级是文件夹
        if (parentItem && parentItem.resourceType === 3) {
          const child = parentList.filter(
            (item) => item.resourceType === 1 && !item.hidden,
          )
          // 只有一个展示的子菜单，高亮他
          if (child && child.length === 1) {
            this.activeMenu = child[0] && child[0].path
            return false
          }
          this.activeMenu = null
          this.$refs.commonMenu && (this.$refs.commonMenu.activeIndex = null)

          // // 菜单下 多个显示页面时
          // if (child && child.length > 1) {
          //   const ind = parentList.findIndex(item => item.resourceKey === name)
          //   // 找显示的页面与当前隐藏菜单最近的前一个页面，高亮他
          //   if (ind > 0) {
          //     const children = parentList.slice(0, ind)
          //     const child1 = children.filter(item => (item.resourceType === 1) && !item.hidden)
          //     if (child1 && child1.length) {
          //       const last = child1[child1.length - 1]
          //       this.activeMenu = last && last.path
          //       return false
          //     }
          //   }
          //   // 兜底，都不匹配时，默认高亮父级下第一个显示的页面
          //   this.activeMenu = child[0] && child[0].path
          // }
        }
      }
    },

    openSubmenu(key) {
      this.$emit('openSubmenuKey', key)
      if (!this.subMenuClick) {
        this.subMenuClick = true
      }
    },
    closeSubmenu(key) {
      this.$emit('closeSubmenuKey', key)
      if (!this.subMenuClick) {
        this.subMenuClick = true
      }
    },

    // 兼容微前端 高亮菜单
    getCurrentActiveMenu() {
      let route
      if (window.__POWERED_BY_QIANKUN__) {
        route = window.$baseRouter && window.$baseRouter.cuRoute
      } else {
        route = this.$route
      }
      // console.log('window.__POWERED_BY_QIANKUN__', window.__POWERED_BY_QIANKUN__)
      // console.log('route', route)
      const { meta, name, path } = route || {}
      const split_list = window.location.pathname.split('/')
      const plateName = split_list[1]
      if (window.__POWERED_BY_QIANKUN__) {
        this.activeMenu = `/${plateName + path}`
        if (path && !this.subMenuClick) {
          if (meta && meta.levels && meta.levels.length > 0) {
            meta.levels.forEach((item) => {
              this.openSubmenu(item)
            })
          } else {
            this.getParentSubMenu(this.activeMenu)
          }
        }
      } else {
        this._getCurrentActiveMenu(meta, name, path)
      }
    },
    // 通过菜单路径找父级目录的key
    getParentSubMenu() {
      // console.log('getParentSubMenu====', secondMenuList, this.activeMenu)
      // 二级菜单list
      const secondMenuList =
        this.parentLayout && this.parentLayout.$data?.secondMenuList
      if (!secondMenuList || secondMenuList.length === 0) return

      for (let i = 0; i < secondMenuList.length; i++) {
        const arr = []
        const subMenuArr = []
        const item = secondMenuList[i]
        // 目标页面无父级页面
        if (item.resourceUrl === this.activeMenu) return
        // 目录资源
        if (
          item.resourceType === 3 &&
          item.subList &&
          item.subList.length > 0
        ) {
          // 将资源打平放到数组arr中
          arr.push({ key: item.resourceKey })
          this.handleSubList(item.subList, item.resourceKey, arr)
        }
        // console.log('arr=====',i, arr)
        // 找到目标路径的页面
        const res = arr.find((menu) => menu.resourceUrl === this.activeMenu)
        if (res) {
          // 获取目标页面所有父级目录的key
          if (res.parent) {
            subMenuArr.push(res.parent)
            this.getParent(res.parent, subMenuArr, arr)
          }
          // console.log('subMenuArr=====', subMenuArr)
          subMenuArr.forEach((citem) => {
            this.openSubmenu(citem)
          })
          return
        }
      }
    },
    handleSubList(list, parentKey, arr) {
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (item.resourceUrl === this.activeMenu) {
          arr.push({
            key: item.resourceKey,
            resourceUrl: item.resourceUrl,
            parent: parentKey,
          })
          return true
        } else if (
          item.resourceType === 3 &&
          item.subList &&
          item.subList.length > 0
        ) {
          arr.push({
            key: item.resourceKey,
            parent: parentKey,
          })
          if (this.handleSubList(item.subList, item.resourceKey, arr)) {
            return true
          }
        }
      }
    },
    getParent(data, subMenuArr, arr) {
      const res = arr.find((item) => item.key === data)
      if (res && res.parent) {
        subMenuArr.push(res.parent)
        this.getParent(res.parent, subMenuArr, arr)
      }
    },
    handleMenuSelect() {
      this.dataBase.deleteAll() // 菜单切换，清除车辆管理页面的筛选条件缓存
      this.canScroll = false
    },
    // 二级菜单滚动到居中位置
    handleScrollPosition() {
      this.$nextTick(() => {
        // 获取真实高度
        const getRealOffsetTop = (el) => {
          let actualTop = el.offsetTop
          let current = el.offsetParent
          while (current !== null) {
            actualTop += current.offsetTop
            current = current.offsetParent
          }
          return actualTop
        }
        // 获取滚动容器
        const scrollBox = this.$refs.commonMenu && this.$refs.commonMenu.$el
        if (!scrollBox) return false
        // 获取当前激活的菜单栏
        const activeDom = scrollBox.querySelector('.el-menu-item.is-active')
        if (activeDom) {
          const activeOffsetTop = getRealOffsetTop(activeDom)
          const scrollBoxHeight = scrollBox.offsetHeight
          const scrollTo = (activeOffsetTop || 0) - (scrollBoxHeight / 2 || 0)
          // 当前菜单栏位置大于 半屏容器高度
          if (activeOffsetTop > scrollBoxHeight / 2) {
            scrollBox.scrollTop = scrollTo
          } else {
            scrollBox.scrollTop = 0
          }
        }
      })
    },
  },
  mounted() {
    // this.getCurrentActiveMenu()
  },
  watch: {
    $route: {
      handler() {
        this.getCurrentActiveMenu()
      },
      immediate: true,
    },
    menuList: {
      handler() {
        this.getCurrentActiveMenu()
      },
      deep: true,
    },
    activeMenu: {
      handler() {
        if (!this.canScroll) {
          this.canScroll = true
        } else {
          this.handleScrollPosition()
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.common-menu {
  width: 100%;
  padding-right: 2px;
  // height: calc(100vh - 56px - 40px);
  flex: 1;
  position: relative;
  overflow: hidden;
  // ::-webkit-scrollbar {
  //   width: 2px!important;
  //   height: 2px!important;
  //   display: none;
  // }

  :v-deep() > div > .el-skeleton {
    padding: 20px;
  }
  .common-menu-loading {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: #fff;
  }
}
// .common-menu {
//   > ::-webkit-scrollbar,
//   > ::-webkit-scrollbar-thumb,
//   > ::-webkit-scrollbar-track {
//     width: 0!important;
//   }
//   &:hover {
//     > ::-webkit-scrollbar,
//     > ::-webkit-scrollbar-thumb,
//     > ::-webkit-scrollbar-track {
//       width: 2px!important;
//     }
//   }
// }
.sidebar-el-menu {
  position: relative;
  overflow-y: scroll;
  top: 0px !important;
  height: 100%;
  overflow-x: hidden !important;
  bottom: 0;
  ::v-deep .el-menu {
    border: none;
    // height: 100%;
    width: 100% !important;
  }
}
::v-deep .sidebar-el-menu.el-menu {
  border: none !important;
}
</style>
